import { IMPORT_TARGET } from './importTargets.js';

/**
 * Header names (Spanish and English) that automap reads as each target. Entries are normalized
 * (lowercase, no accents, single spaces) by `automapColumns` when it builds its lookup. The list is frontend-owned until the
 * backend offers one (ARP-1480).
 */
export const AUTOMAP_SYNONYMS = Object.freeze({
  [IMPORT_TARGET.EMAIL]: [
    'email',
    'e mail',
    'work email',
    'correo',
    'correo electronico',
    'correo de trabajo',
    'mail',
  ],
  [IMPORT_TARGET.FIRST_NAME]: [
    'first name',
    'given name',
    'primer nombre',
    'nombres',
    'nombre de pila',
  ],
  [IMPORT_TARGET.LAST_NAME]: [
    'last name',
    'surname',
    'family name',
    'apellido',
    'apellidos',
  ],
  [IMPORT_TARGET.FULL_NAME]: ['full name', 'nombre completo', 'nombre y apellido'],
  [IMPORT_TARGET.JOB_TITLE]: ['job title', 'title', 'position', 'cargo', 'puesto'],
  [IMPORT_TARGET.LOCATION]: ['location', 'office', 'ubicacion', 'sede', 'oficina'],
  [IMPORT_TARGET.REPORTS_TO]: [
    'reports to',
    'reports to email',
    'manager email',
    'reporta a',
    'jefe directo',
  ],
  [IMPORT_TARGET.USER_TYPE]: ['user type', 'tipo de usuario'],
  [IMPORT_TARGET.ROLES]: ['roles', 'role', 'rol'],
  [IMPORT_TARGET.GROUPS]: ['groups', 'group', 'grupos', 'grupo'],
});

/**
 * Bare "name" / "nombre": a first name when the file also has a last name column, otherwise a
 * full name. Resolved by `automapColumns`, not by exact synonym.
 */
export const AMBIGUOUS_NAME_HEADERS = Object.freeze(['name', 'nombre']);
